import { SubmissionWithOperationDetailsPayload } from "@dune/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const zOperationDescription = z.object({
	operationDescription: z
		.string()
		.min(1, "La description de l'opération est obligatoire"),
	coOwnersSyndicDenomination: z.string().optional(),
});

export type OperationDescriptionFormData = z.infer<
	typeof zOperationDescription
>;

export type OperationDescriptionValues = Omit<
	SubmissionWithOperationDetailsPayload,
	"constructionSite"
>;

export const useOperationDescriptionForm = (
	initialValues?: OperationDescriptionValues,
) => {
	const form = useForm<OperationDescriptionFormData>({
		defaultValues: {
			operationDescription: "",
			coOwnersSyndicDenomination: "",
		},
		resolver: zodResolver(zOperationDescription),
	});
	const { reset } = form;

	useEffect(() => {
		if (initialValues) {
			reset({
				operationDescription: initialValues.operationDescription || "",
				coOwnersSyndicDenomination:
					initialValues.coOwnersSyndicDenomination || "",
			});
		}
	}, [reset, initialValues]);

	return { form };
};
